exports = module.exports = require("../../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".eB8COBCyuQNnHwOD_nVsa ._2EeSIIMMsKDf6faFYvoV6n{z-index:100;color:inherit}.eB8COBCyuQNnHwOD_nVsa ._2EeSIIMMsKDf6faFYvoV6n ._3RVdk8FDrChMBkUj06Hpm0{padding:4px}", ""]);
// Exports
exports.locals = {
	"monaco-editor": "eB8COBCyuQNnHwOD_nVsa",
	"rename-box": "_2EeSIIMMsKDf6faFYvoV6n",
	"rename-input": "_3RVdk8FDrChMBkUj06Hpm0"
};